import BaseForm from '../base';
import { ObjectPanelComponent } from '../components/object';
export class SettingsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new ObjectPanelComponent({
                label: 'Multi-Factor Authentication',
                key: 'twoFactor',
                components: [
                    {
                        label: 'Force Multi-Factor authentication',
                        key: 'enforce',
                        type: 'checkbox',
                    },
                ]
            }),
            new ObjectPanelComponent({
                label: 'Password Rules',
                key: 'passwordRules',
                components: [
                    {
                        label: 'Enabled',
                        key: 'enabled',
                        type: 'checkbox',
                    },
                    {
                        label: 'Unit to be used for expiration',
                        description: 'This unit will be used with the value below',
                        key: 'maxAgeUnit',
                        type: 'select',
                        multi: false,
                        data: {
                            values: [
                                {
                                    label: 'Years',
                                    value: 'years'
                                },
                                {
                                    label: 'Quarters',
                                    value: 'quarters'
                                },
                                {
                                    label: 'Months',
                                    value: 'months'
                                },
                                {
                                    label: 'Days',
                                    value: 'days'
                                }
                            ]
                        },
                        defaultValue: 'days',
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Max expiration value',
                        description: 'For a 90 days expiration, you would select "Days" in `Unit to be used for expiration`' +
                            ' and 90 on this field.<br>Enter -1 to disable age based password expiration',
                        key: 'maxAgeValue',
                        type: 'number',
                        defaultValue: 90,
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Days when the user starts receiving Expiration notifications',
                        description: 'Used to warn user when the password is about to expire',
                        key: 'daysUntilExpiration',
                        type: 'number',
                        defaultValue: 14,
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Max passwords history',
                        description: 'How many passwords the system should remember. The remembered passwords' +
                            ' will not be allowed to be used by the user.<br>Enter -1 to disable password history',
                        key: 'maxHistory',
                        type: 'number',
                        defaultValue: 12,
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Min password length',
                        description: 'Specify the minimum password length',
                        key: 'minLength',
                        type: 'number',
                        defaultValue: 8,
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Required password characters',
                        description: 'By default, lowercase is allowed. Specify which other characters' +
                            ' are required to be used in the password',
                        key: 'charOptions',
                        type: 'select',
                        multiple: true,
                        data: {
                            values: [
                                {
                                    label: 'Uppercase',
                                    value: 'uppercase'
                                },
                                {
                                    label: 'Digits',
                                    value: 'digits'
                                },
                                {
                                    label: 'Symbols',
                                    value: 'symbols'
                                },
                            ]
                        },
                        defaultValue: ['uppercase', 'digits', 'symbols'],
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                    {
                        label: 'Excluded characters when generating random passwords',
                        description: 'The random password generator will exclude the characters specified here',
                        key: 'excludedChars',
                        type: 'textfield',
                        defaultValue: ';"+`{}',
                        conditional: {
                            show: true,
                            when: 'enabled',
                            eq: 'true'
                        },
                    },
                ]
            }),
        ];
    }
}
